import { render, staticRenderFns } from "./AccesoPlataformaReports.vue?vue&type=template&id=2a18b209"
import script from "./AccesoPlataformaReports.vue?vue&type=script&lang=js"
export * from "./AccesoPlataformaReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports